import React from 'react';
import OnboardingPage from './Onboarding';

const Dashboard: React.FC = () => {
  // Instead of showing standalone dashboard, show the OnboardingPage with tabs
  return <OnboardingPage mode="dashboard" />;
};

export default Dashboard;